import { Component, Input } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CoreService } from 'src/app/services/core.service';
import { FileService } from 'src/app/services/file.service';


@Component({
  selector: 'download-document',
  templateUrl: './downloadDocument.component.html',
  styleUrls: []
})
export class DownloadDocumentComponent {
      @Input() downloadDocumentId: string;
      @Input() idIsUserProvided: boolean = false; 

      constructor(private fileService: FileService, private coreService: CoreService) {}

      async downloadDocument(documentId: string): Promise<void> {
        // this component has two ways of receiving a document ID
        // 1. the document is provided from the UI (passed into the component through downloadDocumentId)
        // 2. the id is explicitly provided from a user (documentId)
        if (this.idIsUserProvided) this.downloadDocumentId = documentId;
        try {
          const metadata = await lastValueFrom(this.fileService.downloadFileMetadata(this.downloadDocumentId ));
          await lastValueFrom(this.fileService.downloadFile(this.downloadDocumentId , metadata.documentName));
        } catch (err) {
          this.coreService.popMessage('Error retreiving the document.', 'error', 10000);
        }
      }
}